import * as React from 'react';
import { Input, DatePicker, Row, Col } from 'antd';
import '../../css/TestFilter.scss';
import moment from 'moment';

const { RangePicker } = DatePicker;

interface FilterModalProps {
    filterObj: any;
    handleInputChange: any;
    handleDateRange: any;
}

export default class FilterModal extends React.Component<FilterModalProps, {}> {
    inputEl: any;
    
    render() {
        setTimeout(() => this.inputEl.focus(), 100);
        return(
            <div className="TestFilter"><br/>
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={4} xl={4} />
                    <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                        <div className="label">
                        <span>Username :</span>
                        </div>
                    </Col>
                    <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                        <Input 
                            style={{width: 200}}
                            ref={el => this.inputEl = el}
                            value={this.props.filterObj.username} 
                            onChange={this.props.handleInputChange}
                            autoFocus={true}
                        />
                    </Col>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={4} xl={4} />
                    <Col xs={8} sm={8} md={5} lg={6} xl={5} className="labelFrame">
                        <div className="label">
                            <span>Date Range :</span>
                        </div>
                    </Col>
                    <Col xs={14} sm={14} md={16} lg={10} xl={11}>
                        <RangePicker 
                            onChange={this.props.handleDateRange}
                            format="YYYY-MM-DD"
                            value={this.props.filterObj.dateRange[0] !== '' ?
                                [moment(this.props.filterObj.dateRange[0]), moment(this.props.filterObj.dateRange[1])] 
                                : []}
                        />
                    </Col>
                </Row><br/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/activityFeed/filterModal.tsx